import { render, staticRenderFns } from "./Parser.vue?vue&type=template&id=5bb46746&"
import script from "./Parser.vue?vue&type=script&lang=js&"
export * from "./Parser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports